import axios from "axios";
import { APC_ADDER } from "../../API/Api";

export const GetAllAPCAdders = async () => {
    let headers = {
        Accept: "application/json",
        token: "bL4r$a$c$e6JA8cU",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${APC_ADDER}/adders-installer`,
        headers,
    });
    return response.data;
};

const CreateAPC = async (data) => {
    let headers = {
        Accept: "application/json",
        token: "bL4r$a$c$e6JA8cU",
    };

    let response = await axios({
        method: "POST",
        baseURL: `${APC_ADDER}/adders/apc-adders-store`,
        headers: headers,
        data: data,
    });
    return response.data;
};

const DeleteAPC = async (apc_id) => {
    let headers = {
        Accept: "application/json",
        token: "bL4r$a$c$e6JA8cU",
    };
    let response = await axios({
        method: "DELETE",
        baseURL: `${APC_ADDER}/adders/apc-destroy/${apc_id}`,
        headers: headers,
    });
    return response.data;
};

const ApcAdderService = {
    GetAllAPCAdders,
    CreateAPC,
    DeleteAPC,
};
export default ApcAdderService;
